<div class="fixed-header-margin-distributor">
  <h1>Inventory will go here</h1>
</div>
